import { Navigate, Outlet, useParams } from "react-router-dom";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Card } from "@/core/components/ui/card";
import { ScrollArea, ScrollBar } from "@/core/components/ui/scroll-area";
import {
  SimpleSidebarContent,
  SimpleSidebarLayout,
} from "@/core/components/ui/simple-sidebar";
import { Stack } from "@/core/components/ui/stack/stack";
import { useBusiness } from "@/core/business";
import { useGetMyUser } from "@/user/query";
import BusinessSettingsNavigation from "./business-settings-navigation";
import { BusinessSettingsSidebar } from "./common/business-settings-sidebar";
import { useBusinessSettingsSidebar } from "./context/business-settings-sidebar-context";
import { DeleteUserProvider } from "./users/context/delete-user-context";

const BusinessSettings = () => {
  const { businessId } = useParams();
  const { state, updateSidebar } = useBusinessSettingsSidebar();
  const { data: userInfo, isLoading: isUserLoading } = useGetMyUser();
  const { businessId: userBusinessId, isLoading: isBusinessLoading } =
    useBusiness();

  const isLoading = isUserLoading || isBusinessLoading;

  if (isLoading || !businessId) {
    return (
      <Stack
        direction="row"
        fullWidth
        className="h-[calc(100vh-67px)] px-6 py-8"
      >
        <BusinessSettingsNavigation isLoading />
        <Card className="flex h-full w-full items-center justify-center overflow-auto p-6">
          <LoadingSpinner />
        </Card>
      </Stack>
    );
  }

  if (!businessId || !userBusinessId) {
    return <Navigate to="/" />;
  }

  if (businessId !== userBusinessId) {
    return <Navigate to={`/business-settings/${userBusinessId}`} replace />;
  }

  return (
    <DeleteUserProvider>
      <SimpleSidebarLayout
        open={state.isOpen}
        onOpenChange={(open) => {
          updateSidebar({
            isOpen: open,
            selectedItemId: open ? state.selectedItemId : undefined,
          });
        }}
      >
        <SimpleSidebarContent removeScrollArea>
          <Stack
            direction="row"
            gap="none"
            fullWidth
            className="h-[calc(100vh-67px)]"
          >
            <BusinessSettingsNavigation
              businessId={businessId}
              userRole={userInfo?.role}
            />
            <ScrollArea className="h-full w-full">
              <Stack className="pl-6 pt-8">
                <Outlet />
              </Stack>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
          </Stack>
        </SimpleSidebarContent>
        <BusinessSettingsSidebar businessId={businessId} />
      </SimpleSidebarLayout>
    </DeleteUserProvider>
  );
};

export default BusinessSettings;
